import './style.scss';

const PageDivider = (props: { className?: string }) => {
  return <div className={`${props?.className} page-divider`}></div>;
};

export default PageDivider;
